import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import LinksDefaultColumn from './DefaultVariation'
import LinksColumnV2 from './LinksColumnV2'
import {SpotlightVariation} from './SpotlightVariation'
import {TilesVariation} from './TilesVariation'

/**
 * Props for `LinksColumn`.
 */
export type LinksColumnProps = SliceComponentProps<Content.LinksColumnSlice> & {
  context: {
    shouldHideTitle?: boolean
    pageUid: string
  }
}

/**
 * Component for "LinksColumn" Slices.
 */
const LinksColumn = ({slice, context, index}: LinksColumnProps): JSX.Element => {
  switch (slice.variation) {
    case 'spotlightColumn':
      return <SpotlightVariation slice={slice} componentIndex={index} context={context} />
    case 'linksColumnV2':
      return <LinksColumnV2 slice={slice} componentIndex={index} context={context} />
    case 'tiles':
      return <TilesVariation slice={slice} componentIndex={index} context={context} />
    case 'default':
      return <LinksDefaultColumn slice={slice} componentIndex={index} context={context} />
    default:
      return <></>
  }
}

export default LinksColumn
